import React from "react";
import style from "./index.module.scss";
import { RouteComponentProps } from "react-router-dom";
import useRequest from "utils/useRequest";
import { getVotePaperContent, voteInfoList, VoteState } from "service/vote";
import { toNumber } from "service/service";
import { Spin } from "antd";
import VoteScreen from "./components/VoteScreen";
import VoteStatics from "./components/VoteStatics";
import useChannel from "utils/useChannel";
import { VoteMessage } from "../components/ProjectionLayout/components/VoteModal";

interface VoteDetailProps {
    voteId: string;
}

export default function VoteDetail({
    match
}: RouteComponentProps<VoteDetailProps>) {
    const { voteId } = match.params;
    const [data, dataStatus, refreshData] = useRequest(
        () => getVotePaperContent(toNumber(voteId)),
        {},
        [voteId]
    );
    const [list, listStatus, refreshList] = useRequest(
        () => voteInfoList(toNumber(voteId)),
        {},
        [voteId]
    );

    // 投屏时如果在投票列表里结束活动, 正在进行中的该投票也同时刷新状态
    useChannel<VoteMessage>("vote", message => {
        if (message.type === "onEnd" && message.voteId === toNumber(voteId)) {
            refreshAll();
        }
    });

    function refreshAll() {
        refreshList();
        refreshData();
    }

    return (
        <div className={style.root} key={voteId}>
            {data?.status === VoteState.InProgress && (
                <VoteScreen
                    data={data}
                    stuList={list || []}
                    onCountDown={refreshAll}
                    onChange={refreshAll}
                />
            )}
            {data?.status === VoteState.Done && (
                <VoteStatics stuList={list || []} data={data} />
            )}

            <Spin
                size="large"
                spinning={
                    (dataStatus.loading && data === undefined) ||
                    (listStatus.loading && list === undefined)
                }
                className={style.spin}
            />
        </div>
    );
}
